import React, { useState, useEffect } from 'react';
import { getRegimeHistory } from '../../services/OrdersService';
import { processError } from '../../services/ServiceUtils';

const REGIME_COLORS = {
    TRENDING_UP:     { bg: 'bg-success',              text: 'Tendência ↑' },
    TRENDING_DOWN:   { bg: 'bg-danger',               text: 'Tendência ↓' },
    RANGING:         { bg: 'bg-info text-dark',        text: 'Lateral'     },
    HIGH_VOLATILITY: { bg: 'bg-warning text-dark',     text: 'Alta Vol.'   }
};

function RegimeBadge({ regime }) {
    const c = REGIME_COLORS[regime] || { bg: 'bg-secondary', text: regime };
    return <span className={`badge ${c.bg} py-1 px-2`}>{c.text}</span>;
}

const PAGE_SIZE = 10;

function RegimeHistory({ startDate, endDate }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [page, setPage] = useState(0);

    useEffect(() => {
        if (!startDate || !endDate) return;
        setLoading(true);
        getRegimeHistory(startDate, endDate)
            .then(data => { setRows(data || []); setPage(0); setLoading(false); })
            .catch(err  => { setError(processError(err)); setLoading(false); });
    }, [startDate, endDate]);

    if (loading) return null;
    if (error || !rows.length) return null;

    const pageCount = Math.ceil(rows.length / PAGE_SIZE);
    const paged = rows.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

    return (
        <div className="card card-body border-0 shadow mt-4">
            <h5 className="mb-3">Histórico de Mudanças de Regime <span className="text-muted" style={{ fontSize: '0.7em' }}>({rows.length})</span></h5>
            <div className="table-responsive">
                <table className="table table-hover table-sm mb-0">
                    <thead>
                        <tr className="align-middle">
                            <th>Data/Hora</th>
                            <th>Símbolo</th>
                            <th>Intervalo</th>
                            <th>De</th>
                            <th>Para</th>
                            <th>Confiança</th>
                            <th>ADX</th>
                            <th>ATR%</th>
                            <th>Grid</th>
                            <th>Auto</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paged.map(r => (
                            <tr key={r.id}>
                                <td className="text-nowrap">
                                    <small>{new Date(r.createdAt).toLocaleString()}</small>
                                </td>
                                <td><strong>{r.symbol}</strong></td>
                                <td><small className="text-muted">{r.interval || '—'}</small></td>
                                <td>{r.fromRegime ? <RegimeBadge regime={r.fromRegime} /> : <span className="text-muted">—</span>}</td>
                                <td><RegimeBadge regime={r.toRegime} /></td>
                                <td>{r.confidence != null ? `${(parseFloat(r.confidence) * 100).toFixed(0)}%` : '—'}</td>
                                <td>{r.adx != null ? parseFloat(r.adx).toFixed(1) : '—'}</td>
                                <td>{r.atrPerc != null ? `${parseFloat(r.atrPerc).toFixed(2)}%` : '—'}</td>
                                <td>
                                    {r.gridActivated
                                        ? <span className="badge bg-success">ativado</span>
                                        : <span className="text-muted small">—</span>}
                                </td>
                                <td>
                                    {r.autoSwitchEnabled
                                        ? <span className="badge bg-secondary">auto</span>
                                        : <span className="badge bg-warning text-dark">manual</span>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {pageCount > 1 && (
                <div className="d-flex justify-content-between align-items-center mt-2">
                    <button className="btn btn-sm btn-outline-secondary" disabled={page === 0} onClick={() => setPage(p => Math.max(0, p - 1))}>← Anterior</button>
                    <small className="text-muted">Página {page + 1} de {pageCount}</small>
                    <button className="btn btn-sm btn-outline-secondary" disabled={page >= pageCount - 1} onClick={() => setPage(p => Math.min(pageCount - 1, p + 1))}>Próxima →</button>
                </div>
            )}
        </div>
    );
}

export default RegimeHistory;
